import { render, staticRenderFns } from "./ProfileUniqueSipDigitmap.vue?vue&type=template&id=65edcb4b&"
import script from "./ProfileUniqueSipDigitmap.vue?vue&type=script&lang=js&"
export * from "./ProfileUniqueSipDigitmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports